type Data = {
  [key: string]: string
}

export const parseCell = (input?: string, data?: Data) => {
  const { ozb_tarief, perc_to_high, tax_damage, avg_woz_min_1, avg_woz, woz_increase } = data || {}

  if (woz_increase && parseFloat(woz_increase.replace(',', '.')) < 0)
    input = (input || '').replace(
      'Daarmee is de gemiddelde waarde gestegen met {woz_increase}%',
      `Daarmee is de gemiddelde waarde gedaald met ${woz_increase.replace('-', '')}%`
    )

  return (input || '')
    .replaceAll(/\{ozb_tarief}/g, ozb_tarief)
    .replaceAll(/\{perc_to_high}/g, perc_to_high)
    .replaceAll(/\{perc_to_high}/g, perc_to_high)
    .replaceAll(/\{tax_damage}/g, tax_damage)
    .replaceAll(/\{avg_woz_min_1}/g, avg_woz_min_1)
    .replaceAll(/\{avg_woz}/g, avg_woz)
    .replaceAll(/\{woz_increase}/g, woz_increase)
}

export const parseCellHTML = (input?: string, data?: Data) => {
  return parseCell(input, data)
    .replace(/Kadaster/g, '<a href="https://www.kadaster.nl/" target="_blank">Kadaster</a>')
    .replace(/Het WOZ-Waardeloket/g, '<a href="https://www.wozwaardeloket.nl/" target="_blank">Het WOZ-Waardeloket</a>')
    .replace(
      /Vereniging Eigen Huis/g,
      '<a href="https://www.eigenhuis.nl/wonen/belastingen/woz/woz-bezwaar-maken" target="_blank">Vereniging Eigen Huis</a>'
    )
}
